module.exports = "/_next/static/images/OgDeveloperToolkit-0e3ddff026b70c090c7df37ad397052c.jpg";